module.exports = __webpack_public_path__ + "static/media/iconfinder_Tick_Mark_Circle_1398913.2fc45547.png";